import { Link } from 'react-router';
import { UniversalPage, Card } from '@sighthost/ui';

export default function NotFound() {
  return (
    <UniversalPage title="Page not found">
      <Card interactive={false} className="p-12 text-center">
        <p className="mb-4 text-sm text-muted-foreground">
          The page you tried to reach does not exist.
        </p>
        <Link
          to="/app"
          className="text-sm font-medium text-primary-ink hover:underline"
        >
          Return to dashboard
        </Link>
      </Card>
    </UniversalPage>
  );
}
